/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const privacyPolicyDataSchema = z.object({
	organisationInformation: z.object({
		companyName: z.string().nullable(),
		streetAddress: z.string().nullable(),
		postalCode: z.string().nullable(),
		city: z.string().nullable(),
		country: z.string().nullable(),
		phoneNumber: z.string().nullable(),
		emailAddress: z.string().nullable(),
	}),
	dataProtectionOfficer: z.object({
		name: z.string().nullable().optional(),
		phoneNumber: z.string().nullable().optional(),
		emailAddress: z.string().email().nullable().optional(),
	}).nullable(),
})

export type PrivacyPolicyDataSchema = z.infer<typeof privacyPolicyDataSchema>
